import { useEffect } from "react"

const DownloadApp = () => {
  useEffect(() => {
    const userAgent = navigator.userAgent || navigator.vendor
    const isAndroid = /android/i.test(userAgent)
    const isIOS =
      /iPad|iPhone|iPod/.test(userAgent) ||
      (navigator.userAgent.includes("Mac") && "ontouchend" in document)

    if (isAndroid) {
      window.location.href =
        "https://play.google.com/store/apps/details?id=com.walkme.walkmeapp"
    } else if (isIOS) {
      window.location.href =
        "https://apps.apple.com/us/app/lets-hang/id1547911833"
    } else {
      window.location.href =
        "https://apps.apple.com/us/app/lets-hang/id1547911833"
    }
  }, [])

  return <h2>Redirecting...</h2>
}

export default DownloadApp
